import React, { Component } from "react";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import classNames from "classnames/bind";
import ProductList from "../ProductList";
import ErrorAlert from "../ErrorAlert";
import SmallScreenHeader from "../../containers/SmallScreenHeader";
import MediumLargeScreenHeader from "../../containers/MediumLargeScreenHeader";
import LayoutManagerContainer from "../../containers/LayoutManager";
import SearchTerm from "../SearchTerm";
import styles from "./ProductListingPage.css";
import RenderToggle from "../RenderToggle";
import addFeatureToggleClasses from "../../helpers/addFeatureToggleClasses";

const styleContext = classNames.bind(styles);

const isNewLocation = (prevProps, nextProps) =>
  prevProps.location !== nextProps.location;

const shouldScrollToTop = (prevProps, nextProps) =>
  isNewLocation(prevProps, nextProps) && nextProps.isNewSearch;

export class ProductListingPage extends Component {
  constructor(props) {
    super(props);

    props.setPageName(props.route.pageName);
  }

  componentWillUpdate(nextProps) {
    if (shouldScrollToTop(this.props, nextProps)) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    const { featureToggles, hasFacets } = this.props;
    if (CLIENT) {
      const wrapper = document.body;

      if (wrapper) {
        addFeatureToggleClasses(wrapper, featureToggles);
      }
    }

    return (
      <React.Fragment>
        <div
          className={styleContext({
            container: true,
            wrapper: hasFacets
          })}
        >
          <LayoutManagerContainer />
          <SearchTerm />
          <RenderToggle isToRender={hasFacets}>
            <div>
              <SmallScreenHeader />
              <MediumLargeScreenHeader />
            </div>
          </RenderToggle>
          <ProductList {...this.props} />
          <ErrorAlert />
        </div>
      </React.Fragment>
    );
  }
}

ProductListingPage.propTypes = {
  itemCount: PropTypes.number.isRequired,
  featureToggles: PropTypes.object.isRequired,
  setPageName: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  error: PropTypes.object,
  route: PropTypes.shape({
    pageName: PropTypes.string.isRequired
  }).isRequired,
  isNewSearch: PropTypes.bool,
  hasFacets: PropTypes.bool.isRequired
};

ProductListingPage.defaultProps = {
  featureToggles: {}
};

export default withRouter(ProductListingPage);
